import { useAuthController } from 'core/user/auth';
import { useHasAccess, USER_ROLE } from 'core/user/role';
import { useUser } from 'core/user/user';
import AppPage from 'pages/shared/AppPage';
import NotFoundPage from 'pages/shared/NotFoundPage';
import useMount from 'utils/hooks/useMount';

const PageWrapper = ({ component, role }) => {
  const { hasAccess } = useHasAccess();

  return hasAccess(role) ? <AppPage component={component} /> : <NotFoundPage />;
};

const ProtectedPage = ({ component, role = USER_ROLE.viewer }) => {
  const { user } = useUser();
  const { login } = useAuthController();

  useMount(() => {
    if (!user) {
      login();
    }
  });

  return user ? <PageWrapper component={component} role={role} /> : null;
};

export default ProtectedPage;
